// // reducer.ts
// import { CHANGE_MODULE, ChangeModuleAction, Module } from '../actions/moduleAction';

// interface ModuleState {
//   currentModule: Module[]; // Use the new Module type
// }

// const initialState: ModuleState = {
//   currentModule: [],
// };

// const moduleReducer = (
//   state: ModuleState = initialState,
//   action: ChangeModuleAction
// ): ModuleState => {
//   switch (action.type) {
//     case CHANGE_MODULE:
//       const newModules = Array.isArray(action.payload) ? action.payload : [action.payload];
//       // If the currentModule array is empty, set the first item as the initial module
//       const updatedModules = state.currentModule.length === 0 ? newModules : [...state.currentModule, ...newModules];
//       return {
//         ...state,
//         currentModule: updatedModules,
//       };
//     default:
//       return state;
//   }
// };

// export default moduleReducer;


import { CHANGE_MODULE, ChangeModuleAction, Module } from '../actions/moduleAction';

interface ModuleState {
  currentModule: Module[];
  // modulesSyllabus: ModuleSyllabus[];
}

const initialState: ModuleState = {
  currentModule: [],
  // modulesSyllabus: [],
};

const moduleReducer = (
  state: ModuleState = initialState,
  action: ChangeModuleAction
): ModuleState => {
  switch (action.type) {
  
    case CHANGE_MODULE:
      
      const newModules = Array.isArray(action.payload.modules) ? action.payload.modules : [action.payload.modules];
      return {
        ...state,
        currentModule: newModules,
        // Access moduleName from action.payload if needed
      };
    
    default:
      return state;
  }
};

export default moduleReducer;
